import React from 'react'
import { Helmet } from 'react-helmet'
import VideosDetail from './videos-detail'
import SimplifiedFooter from '../../partials/footer/simplified'
import NoContextHeader from '../../partials/header/no-context-header'
import { Loading } from '../../../shared/ui/loading'
import { useData } from '../../../shared/hooks/use-data'

const VideosDetailContainer = props => {
  const { state, result, error } =  useData(`/api/videos/${props.match.params.id}`)
  const isLoading = state === 'PENDING'

  return (
    <>
      <Helmet>
        {!isLoading && !error && <title>{result.title} - VicBooth</title>}
      </Helmet>
      <NoContextHeader />
      {isLoading
        ? <div><Loading /></div>
        : error || <VideosDetail {...result} />}
      <SimplifiedFooter />
    </>
  )
}

export default VideosDetailContainer
